import React from 'react';
import PropTypes from 'prop-types';
import sotyPageQuery from './query.graphql';

import { ShopOfTheYearLeaderboard, ShopOfTheYearWinners } from '.';

const ShopOfTheYear = ({ data }) => {
  const { isVotingOpen, year } = data.shopOfTheYear;

  return isVotingOpen ? (
    <ShopOfTheYearLeaderboard
      data={data}
      key={`shopOfTheYearLeaderboard${year}`}
    />
  ) : (
    <ShopOfTheYearWinners
      data={data}
      key={`shopOfTheYearWinners${year}`}
      isMainPage
    />
  );
};

ShopOfTheYear.graphQL = sotyPageQuery;

ShopOfTheYear.propTypes = {
  data: PropTypes.object.isRequired,
};

ShopOfTheYear.variables = ({ year, shop }) => ({
  year: parseInt(year, 10) || undefined,
  shopId: shop,
});

export default ShopOfTheYear;
